import { useEffect, useState, useCallback } from "react";
import { RefreshCcw, CreditCard, ExternalLink } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { btn, btnLight, Card, H, errMsg } from "./shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ah = () => ({ withCredentials: true });

export const Subscriptions = ({ l, lang }) => {
  const [subs, setSubs] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => axios.get(`${API}/account/subscriptions`, ah()).then((r) => setSubs(r.data)).catch(() => setSubs([])), []);
  useEffect(() => { load(); }, [load]);

  const act = async (s, action) => {
    if (action === "cancel" && !window.confirm(l.confirmCancel)) return;
    setBusy(true);
    try { await axios.post(`${API}/account/subscriptions/${s.id}/${action}`, {}, ah()); toast.success(action === "cancel" ? l.cancelled : l.resumed); load(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const portal = async () => {
    setBusy(true);
    try { const r = await axios.post(`${API}/account/billing-portal`, { origin_url: window.location.origin }, ah()); window.location.href = r.data.url; }
    catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  const fmt = (iso) => new Date(iso).toLocaleDateString(lang === "fr" ? "fr-CH" : "en-GB", { dateStyle: "long" });

  return (
    <div className="grid lg:grid-cols-[1fr_360px] gap-6">
      <Card data-testid="account-subscriptions">
        <H>{l.title}</H>
        {subs === null ? <p className="text-sm text-stone-500 font-mono">…</p> : subs.length === 0 ? <p className="text-sm text-stone-500" data-testid="subs-empty">{l.none}</p> : (
          <ul className="divide-y divide-stone-100">
            {subs.map((s) => (
              <li key={s.id} className="py-4 flex flex-wrap items-center gap-4" data-testid={`sub-${s.id}`}>
                <span className="w-10 h-10 rounded-full bg-[#4A624E]/10 text-[#4A624E] flex items-center justify-center"><RefreshCcw size={15} /></span>
                <div className="flex-1 min-w-[180px]">
                  <p className="text-stone-900">{s.name}</p>
                  <p className="text-[11px] font-mono text-stone-500">{s.amount.toFixed(2)} {s.currency} {l.perMonth} · {l.status[s.status] || s.status}{s.cancel_at_period_end ? ` · ${l.cancelling}` : ""}</p>
                  <p className="text-[11px] text-stone-500">{l.next} : {fmt(s.current_period_end)}</p>
                </div>
                {s.status !== "canceled" && (s.cancel_at_period_end
                  ? <button data-testid={`sub-resume-${s.id}`} disabled={busy} onClick={() => act(s, "resume")} className={btn}>{l.resume}</button>
                  : <button data-testid={`sub-cancel-${s.id}`} disabled={busy} onClick={() => act(s, "cancel")} className={`${btnLight} hover:!border-rose-600 hover:!text-rose-700`}>{l.cancel}</button>)}
              </li>
            ))}
          </ul>
        )}
      </Card>
      <Card data-testid="account-portal">
        <H>{l.portalTitle}</H>
        <CreditCard size={20} className="text-stone-400" />
        <p className="mt-3 text-sm text-stone-600 leading-relaxed">{l.portalBody}</p>
        <button data-testid="account-portal-open" disabled={busy} onClick={portal} className={`${btn} mt-5`}><ExternalLink size={13} /> {l.portal}</button>
      </Card>
    </div>
  );
};
